import {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {DateUtil} from "base/format/utilities";
import {FormDatePicker} from ".";
import Grid from "@mui/material/Grid";

const FormDatePickerCombo = ({
    startDateName,
    startDateLabel,
    endDateName,
    endDateLabel,
    minStartDate = null,
    maxEndDate = null,
    disableFuture = false,
    required = false,
    disabled = false,
}) => {
    const {watch, clearErrors, trigger} = useFormContext();
    const [minEndDate, setMinEndDate] = useState(null);

    const startDate = watch(startDateName);

    useEffect(() => {
        if (startDate) {
            setMinEndDate(new Date(startDate));
        }
    }, [startDate]);

    useEffect(() => {
        if (minEndDate) {
            clearErrors(endDateName);
            trigger(endDateName);
        }
    }, [minEndDate, endDateName]);

    return (
        <>
            <Grid item xs={12} sm={6}>
                <FormDatePicker
                    name={startDateName}
                    label={startDateLabel}
                    disabled={disabled}
                    disableFuture={disableFuture}
                    minDate={DateUtil.parseDateFromApi(minStartDate)}
                    rules={{
                        required: required,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormDatePicker
                    name={endDateName}
                    label={endDateLabel}
                    disabled={disabled}
                    disableFuture={disableFuture}
                    minDate={minEndDate}
                    maxDate={DateUtil.parseDateFromApi(maxEndDate)}
                    rules={{
                        required: required,
                    }}
                />
            </Grid>
        </>
    );
};

export default FormDatePickerCombo;
